export default __webpack_public_path__ + "static/media/emoji_happiness.863cf282.png";